import React from "react";
import { SUBSCRIPTION_STATUS_MAP } from "features/Crm/constants/SubscriptionStatus.constants";

export const SubscriptionStatus = ({ status }) => {
  const { className, title } = SUBSCRIPTION_STATUS_MAP[status];
  return <span className={className}>{title}</span>;
};
